import { axios } from '../../../lib/axios';
import { SurveyItem } from '../types/index.ts'

export const getPendigSurveyAPI = async (): Promise<SurveyItem[]> => {
    const response = await axios.get('/survey/pending') as { items: SurveyItem[] };
    return response;
};
